<template>
  <div>
    <div id="chart-container" class="moats">
      <div v-show="!generatingChart && displayChart" id="moat-rank-title-and-chart" class="title-and-chart">
        <profile-chart-header
            :title="'Rank | ' + titleSuffix"
            :display="!generatingChart"
            :content-list="pageContent"
            :content-name="'Moneyball Rank'"
            :display-show-respondents="false"
            :display-sort-by="false"
            :display-show-tooltip="false"
            @set-sort-by="setSortBy"
            @set-display-number-of-responses="setDisplayNumberOfResponses"
            @set-show-tooltip="setShowTooltip"
          />
      </div>
    </div>
    <insights
      ref="insightsChart"
      :modal-name="'moat-rank'"
      :report-page-type-name="'Chart - Moneyball Stick Rank'"
      :entry-page-content="this.pageContentForReport"
      @saveReportPage="$parent.updateReportPages"
      @saveAllReportPages="saveAllReportPages"
      @saveClientChart="$parent.saveClientChart"
    />
  </div>
</template>
<script>
import ChartCompanyMixins from "../../../mixins/ChartCompanyMixins.vue";

import ProfileChartHeader from "../../../components/echarts/ProfileChartHeader.vue";


import ReportService from "../../../services/report.service";
import ErrorService from "../../../services/error.service";

export default {
  name: "MoneyballStickRank",
  mixins: [ChartCompanyMixins],
  components: {ProfileChartHeader},
  data() {
    return {
      title: "Moneyball Rank",
      isMobile: false,
      displayChart: false,
      titleSuffix: "",
    };
  },
  props: {
    inputData: {
      type: Object,
      default: function() {
        return {};
      }
    },
  },
  methods: {
    saveAllReportPages() {
      this.saveReportPage("moat-rank","Chart - Moneyball Stick Rank",this.clientChart);
    },     
    async saveProfileDataTable(containerId) {},  
    async processChartData() {
      try {
        let moneyballStickResults = JSON.parse(JSON.stringify(this.inputData));
        let titleSuffix = moneyballStickResults["titleSuffix"];
        if (typeof titleSuffix != "undefined" && titleSuffix != null && titleSuffix != "") {
          this.titleSuffix = titleSuffix;
        }
        this.displayChart = moneyballStickResults.displayChart;
      } catch (err) {
        ErrorService.processException("MoneyballStickRank.displayChartCallback", err, "chart", this);
      }
    },
  },
  umnounted() {},
  computed: {},
  mounted() {
    this.getPageContent("Ranks");
  },
  created() {},
  watch: {
    inputData: function() {
      if (this.$parent.$refs.chartCriteria.$data.displayType == "moat-rank") {
        this.processChartData();
      } else {
        this.setDisplayView(false);
      }
    }
  }
};
</script>
